module.exports = __webpack_public_path__ + "img/login-icon-advertise.c093e5a4.png";